import gql from 'graphql-tag';
import {
  isArray,
  isArrayOfGenerator,
  isBoolean,
  isString,
  typeGuardGenerator,
} from '@metools/tcheck';

import { alertsApolloClient } from '../../helpers/api';

/**
 * @typedef {object} AlertObject
 * @property {string} notificationId
 * @property {string} created_at
 * @property {string} source
 * @property {string} action
 * @property {string} title
 * @property {string} subtitle
 * @property {string} message
 * @property {string} payload
 * @property {boolean} isRead
 * @property {string} timestamp
 */

/** @type {import('@metools/tcheck').TypeGuard<AlertObject>} */
export const isAlertObject = typeGuardGenerator({
  notificationId: isString,
  created_at: isString,
  source: isString,
  action: isString,
  title: isString,
  subtitle: isString,
  message: isString,
  payload: isString,
  isRead: isBoolean,
  timestamp: isString,
});

// const isAlertObjectArray = isArrayOfGenerator(isAlertObject);

/**
 * @param {string} userId The user id for which to fetch alerts
 * @returns {Promise<AlertObject[]>} The fetched alerts
 */
export async function fetchAlerts(userId) {
  // Notification Schema:
  // type Notification {
  //   notificationId: String!
  //     @aws_iam
  //   @aws_oidc
  //   source: String!
  //   action: String!
  //   userId: String!
  //   title: String!
  //   subtitle: String!
  //   message: String!
  //   payload: String!
  //   isRead: Boolean!
  //     @aws_subscribe(mutation: "markNotificationsAsRead")
  //   timestamp: String!
  //   created_at: String!
  //   app: Application
  // }
  const response = await alertsApolloClient.query({
    query: gql`
      query gn{
        getNotificationsByUser(userId: "${userId}") {
          notificationId
          created_at
          source
          action
          title
          subtitle
          message
          payload
          isRead
          timestamp
        }
      }
    `,
    fetchPolicy: 'no-cache',
  });

  const getNotificationsByUser = response?.data?.getNotificationsByUser;

  if (!isArray(getNotificationsByUser)) {
    throw new Error('Invalid alert data received from server');
  }

  const output = getNotificationsByUser.filter(isAlertObject);

  output.sort((a, b) => parseInt(b.created_at) - parseInt(a.created_at));

  return output;
}
